var exports = {
  "y": "xfb577c5e--22d035--links",
  "n": "xfb577c5e--22d035--link",
};

module.exports = exports;
